import { useExperiments } from '@wix/fe-essentials-standalone';
import { useRouter } from 'next/router';

import { EXPERIMENTS, LOCALES } from '../constants';
import { useStore } from '../zustand/stores';

const UNSUPPORTED_LOCALES = [LOCALES.HE, LOCALES.UK, LOCALES.HI, LOCALES.ZH_HANT];

const useIsSearchRedirectToContactEnabled = () => {
  const { experiments } = useExperiments({ suspense: false, readOnly: true });
  const { user } = useStore((state) => state.userSlice);
  const { locale } = useRouter();

  if (!user || UNSUPPORTED_LOCALES.includes(locale as string)) {
    return false;
  }

  if (experiments.get(EXPERIMENTS.SPECS.USE_UNIFIED_GENERATION_PROMPT) !== 'C') {
    return false;
  }

  return experiments.enabled(EXPERIMENTS.SPECS.SEARCH_REDIRECT_TO_CONTACT);
};

export default useIsSearchRedirectToContactEnabled;
